module.exports = __webpack_public_path__ + "img/stone-brick.03e1ebe4.png";